import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { text: String }

  copy() {
    navigator.clipboard.writeText(this.textValue).then(() => {
      const icon = this.element.querySelector("svg")
      icon.classList.add("text-azure-400")
      setTimeout(() => icon.classList.remove("text-azure-400"), 1000)
    })
  }
}
